import { render } from "./diana.vue?vue&type=template&id=3d58b789&scoped=true"
import script from "./diana.vue?vue&type=script&lang=js"
export * from "./diana.vue?vue&type=script&lang=js"

import "./diana.vue?vue&type=style&index=0&id=3d58b789&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d58b789"]])

export default __exports__